import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcab() {



const cardData = {
  keyword: " Pune to Mumbai Airport Cabs ",

headingDescription:
  "Velocity Cab provides punctual and comfortable Pune to Mumbai Airport cabs, ensuring a seamless transfer whether you’re heading to **Chhatrapati Shivaji Maharaj International Airport (BOM)** for business or leisure travel. Our professional drivers, well‑maintained vehicles, and easy booking options make your airport journey stress‑free and comfortable. Choose from one‑way, round‑trip, or customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars to accommodate solo travelers, families, and corporate groups. With reliable pickup from any location in Pune, real‑time flight tracking, and 24/7 customer support, Velocity Cab ensures you reach Mumbai Airport on time, every time.",

topPlaces: [
  {
    title: "Chhatrapati Shivaji Maharaj International Airport (Terminal 1 & 2)",
    description:
      "Chhatrapati Shivaji Maharaj International Airport is Mumbai’s primary domestic and international airport, handling millions of travelers each year. With Velocity Cab’s Pune to Mumbai Airport service, you enjoy on‑time pickups, flight tracking, and a comfortable ride directly to the correct terminal, making your departure or arrival smooth and stress‑free."
  },
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic historical landmarks located by the Arabian Sea in South Mumbai. Travelers who arrive via Pune to Mumbai airport often choose to visit this monumental arch for sightseeing, photography, and ferry rides to Elephanta Island. A reliable cab service ensures safe travel from the airport to this top attraction."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive, known as the Queen’s Necklace, is a scenic coastal boulevard offering breathtaking views of the Arabian Sea and iconic skyline. Many visitors arriving at Mumbai Airport opt to visit Marine Drive in a comfortable cab to enjoy a serene walk or a sunset drive after their flight."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, known for lively sunsets, street food, and seaside ambience. Travelers arriving by Pune to Mumbai Airport cab can enjoy local snacks like pav bhaji and pani puri while soaking up the coastal vibe along this expansive stretch of sand."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha, located in Prabhadevi. Visitors to Mumbai often choose to stop by this sacred site after their airport arrival for blessings, spiritual reflection, and to admire the temple’s beautiful architecture."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern engineering marvel connecting Bandra and Worli, offering impressive sea and skyline views. Travelers arriving at the airport often request a scenic cab drive over this landmark as part of their Mumbai sightseeing experience."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a spiritual and cultural landmark located on a small island off the Mumbai coast. After landing in Mumbai, many visitors arrange a cab to this peaceful shrine to soak up both the spiritual and sea views along the walkway leading to the mosque."
  },
  {
    title: "Elephanta Caves",
    description:
      "The UNESCO World Heritage‑listed Elephanta Caves are ancient cave temples on Elephanta Island. Many travelers arriving via Pune to Mumbai Airport cab first head to the Gateway of India to take a ferry to this fascinating archaeological site known for its historic carvings."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve offering trekking, wildlife, and nature experiences. After their flight, travelers sometimes request a cab to this green getaway for a break from the city’s hustle and bustle and to explore nature trails and the Kanheri Caves."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping and cultural street in South Mumbai known for its markets, cafes, and handicrafts. Many travelers arriving at the Mumbai Airport enjoy taking a cab to this vibrant area to shop, eat, and explore local culture."
  }
],



services: [
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable transportation for passengers traveling from Pune to Mumbai’s international and domestic airport terminals. Professional drivers ensure safe and punctual journeys via the Mumbai–Pune Expressway. Vehicles are well maintained and offer comfortable seating with sufficient luggage space for airport travel. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for business travelers, tourists, and families. Flexible booking options allow advance reservations for timely airport transfers."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai Airport cab fare services provide transparent pricing for travelers planning airport transfers. Passengers receive clear details about per-kilometer fares, toll charges, and driver allowances before confirming the booking. Vehicles are comfortable and suitable for long-distance expressway travel. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for business travelers and international passengers. Flexible booking options help travelers plan convenient airport transportation."
},
{
name: "Pune to Mumbai Airport",
description: "Pune to Mumbai Airport travel services offer convenient transportation for passengers flying from Mumbai’s major airport terminals. Comfortable vehicles with professional drivers ensure smooth journeys across the expressway. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for domestic and international travelers carrying luggage. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow passengers to schedule rides according to flight timings."
},
{
name: "Pune to Mumbai Taxi Service",
description: "Pune to Mumbai taxi service provides dependable transportation between the two major cities of Maharashtra. Professional drivers ensure safe driving and punctual pickup services for passengers traveling via the expressway. Vehicles are well maintained and suitable for airport transfers, business travel, and tourism trips. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Comfortable interiors ensure smooth long-distance journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Pune to Mumbai Airport Cab Price",
description: "Pune to Mumbai Airport cab price services help travelers find competitive and transparent travel rates for airport transfers. Passengers can compare fares and choose vehicles suitable for their travel needs. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for business travel, tourism visits, and international departures. Flexible booking options allow convenient ride planning."
},
{
name: "Pune Mumbai Airport Car Hire",
description: "Pune Mumbai Airport car hire service offers comfortable vehicle rental for travelers heading to Mumbai Airport. Vehicles are well maintained and suitable for highway journeys with professional drivers ensuring safe travel. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for families, business travelers, and tourists. Spacious interiors provide comfortable travel experiences during airport transfers. Flexible booking options allow convenient car hire reservations."
},
{
name: "Pune to Mumbai Airport Cab Booking",
description: "Pune to Mumbai Airport cab booking service allows travelers to reserve reliable transportation for timely airport transfers. Online booking options make it easy to confirm rides with transparent pricing and flexible scheduling. Vehicles are comfortable and suitable for expressway travel. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for business travelers and international passengers. Advance booking ensures stress-free airport journeys."
},
{
name: "Pune to Mumbai Airport Taxi Fare",
description: "Pune to Mumbai Airport taxi fare services offer clear and competitive pricing for passengers traveling between Pune and Mumbai Airport. Travelers can easily estimate trip costs before confirming bookings. Vehicles provide comfortable seating and luggage space suitable for airport travel. Professional drivers ensure safe driving and punctual pickups. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Flexible booking options allow convenient travel planning."
},
{
name: "Pune to Mumbai Airport Drop",
description: "Pune to Mumbai Airport drop service provides reliable one-way transportation for passengers heading to airport terminals in Mumbai. Professional drivers ensure safe and punctual journeys via the expressway. Vehicles are comfortable and suitable for passengers traveling with luggage. Pickup services are available from homes, hotels, offices, and railway stations in Pune. Ideal for business travelers and international flyers. Flexible booking options allow quick ride reservations."
},
{
name: "Mumbai to Pune Innova Crysta Cab Booking",
description: "Mumbai to Pune Innova Crysta cab booking service offers premium SUV transportation for travelers seeking comfort and luxury. Innova Crysta vehicles provide spacious seating and smooth ride quality ideal for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate executives and family travel. Flexible booking options allow convenient reservations."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service provides convenient return transportation for travelers planning journeys between the two cities. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business meetings, tourism trips, and family travel. Air-conditioned vehicles ensure comfortable long-distance rides. Flexible booking options allow easy round-trip reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV travel for passengers traveling with families or groups. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys. Professional drivers ensure punctual pickup and safe driving services across the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service offers premium SUV transportation for comfortable highway travel. Innova vehicles provide spacious seating and smooth ride quality suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel and family trips. Flexible booking options allow easy reservations."
},
{
name: "Pune to Mumbai Airport Cab Service",
description: "Pune to Mumbai Airport cab service offers dependable transportation for passengers traveling to Mumbai Airport terminals. Vehicles are well maintained and suitable for long-distance airport transfers with comfortable seating and luggage space. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, and railway stations in Pune. Ideal for domestic and international travelers. Flexible booking options allow advance ride reservations."
},
{
name: "Pune to Mumbai Airport Taxi",
description: "Pune to Mumbai Airport taxi service provides comfortable transportation for passengers heading to Mumbai Airport terminals. Vehicles offer smooth expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for business travelers, tourists, and families. Spacious vehicles ensure comfortable travel experiences. Flexible booking options allow easy taxi reservations."
},
{
name: "Pune to Mumbai Airport Innova",
description: "Pune to Mumbai Airport Innova cab service provides luxury SUV transportation for airport travelers seeking comfort and reliability. Innova vehicles offer spacious seating and luggage space ideal for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across the expressway. Pickup services are available from homes, hotels, offices, and railway stations in Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune to Mumbai Airport Drop Cab",
description: "Pune to Mumbai Airport drop cab service provides reliable one-way transportation for passengers traveling from Pune to Mumbai Airport. Vehicles are comfortable and suitable for long-distance highway journeys with luggage space for travelers. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and railway stations. Flexible booking options allow convenient airport ride scheduling."
},
{
name: "Pune to Mumbai Airport Drop Taxi",
description: "Pune to Mumbai Airport drop taxi service offers dependable one-way transportation for passengers traveling to airport terminals in Mumbai. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for international travelers and business passengers. Flexible booking options allow quick taxi reservations."
},
{
name: "Pune to Mumbai Airport Terminal 2",
description: "Pune to Mumbai Airport Terminal 2 cab service provides comfortable transportation for passengers traveling to Mumbai’s international airport terminal. Vehicles offer spacious seating and luggage space suitable for international travelers. Professional drivers ensure punctual pickup and safe highway travel. Pickup services are available from homes, hotels, offices, and railway stations in Pune. Flexible booking options allow convenient airport ride planning."
},
{
name: "Pune to Mumbai Airport Terminal 1",
description: "Pune to Mumbai Airport Terminal 1 cab service offers reliable transportation for passengers traveling to the domestic terminal in Mumbai. Comfortable vehicles with professional drivers ensure safe and punctual expressway journeys. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for domestic travelers and business trips. Flexible booking options allow convenient airport taxi reservations."
},
{
name: "Pune to Mumbai Airport Terminal 3",
description: "Pune to Mumbai Airport Terminal 3 cab service offers dependable transportation for travelers heading to Mumbai Airport terminals. Vehicles are well maintained and suitable for long-distance expressway travel with luggage space for passengers. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow travelers to schedule rides according to their flight timings."
},
{
name: "Mumbai Airport Taxi from Pune",
description: "Mumbai Airport taxi from Pune service provides convenient airport transportation for passengers traveling between Pune and Mumbai Airport. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, hotels, offices, and railway stations in Pune. Ideal for business travelers, tourists, and families. Flexible booking options allow advance airport taxi reservations."
}
],

tableData: [
["Pune to Mumbai Airport Cab","Pune to Mumbai Airport Cab Fare"],
["Pune to Mumbai Airport","Pune to Mumbai Taxi Service"],
["Pune to Mumbai Airport Cab Price","Pune Mumbai Airport Car Hire"],
["Pune to Mumbai Airport Cab Booking","Pune to Mumbai Airport Taxi Fare"],
["Pune to Mumbai Airport Drop","Mumbai to Pune Innova Crysta Cab Booking"],
["Pune to Mumbai Cab Round Trip","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune to Mumbai Airport Cab Service"],
["Pune to Mumbai Airport Taxi","Pune to Mumbai Airport Innova"],
["Pune to Mumbai Airport Drop Cab","Pune to Mumbai Airport Drop Taxi"],
["Pune to Mumbai Airport Terminal 2","Pune to Mumbai Airport Terminal 1"],
["Pune to Mumbai Airport Terminal 3","Mumbai Airport Taxi from Pune"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Airport Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Airport Route Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who are familiar with Pune to Mumbai Airport routes including the Mumbai Pune Expressway and city airport terminals. Our drivers ensure timely pickups and smooth airport transfers for a stress-free travel experience."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Pune to Mumbai Airport cab bookings. Customers receive complete fare details including toll charges, driver allowance, and airport drop costs before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai Airport cab service operates 24 hours a day to match your flight schedule. Whether you have an early morning departure or late night arrival, Velocity Cabs ensures reliable airport transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable journey from Pune to Mumbai Airport."
  },
  {
    WhyChooseheading: "Flexible Airport Pickup & Drop",
    WhyChoosedescription: "Velocity Cabs provides flexible travel options including one-way airport drop, airport pickup from Mumbai, and round-trip airport transfer services between Pune and Mumbai Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, business travelers, and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and railway stations across Pune including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Reliable Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by travelers for Pune to Mumbai Airport cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Pune to Mumbai Airport?", answer: "Yes, Velocity Cabs provides reliable airport drop services from Pune to Mumbai Airport with comfortable vehicles and professional drivers." },
  { question: "Is Pune to Mumbai Airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight schedules." },
  { question: "Which vehicles are available for Pune to Mumbai Airport transfers?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way airport drop?", answer: "Yes, Velocity Cabs provides one-way airport drop services from Pune to Mumbai Airport." },
  { question: "Do you provide pickup from homes and hotels in Pune?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and business locations across Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable airport travel." },
  { question: "Can I book Pune to Mumbai Airport cab service online?", answer: "Yes, customers can easily book airport cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for early morning or late-night flights." },
  { question: "Do you provide airport pickup from Mumbai Airport to Pune?", answer: "Yes, Velocity Cabs provides airport pickup service from Mumbai Airport to Pune as well." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very timely and comfortable Pune to Mumbai Airport drop experience. The cab was clean, the ride was smooth, and everything was managed perfectly for an on-time arrival.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Mumbai Airport drop service was extremely reliable. The driver was punctual, the vehicle was well-maintained, and the journey felt stress-free and safe.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides the best Pune to Mumbai Airport cab service with affordable pricing and professional drivers. Book one-way or round-trip airport cabs including Ertiga, Innova, and Innova Crysta for Mumbai Airport Terminal 1 and Terminal 2 transfers. Enjoy safe, comfortable, and punctual rides with easy booking and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Airport Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport cab with Velocity Cabs. Reliable taxi service for Terminal 1 & 2 transfers, one-way & round trip rides, Innova, Ertiga & Crysta cabs. Affordable, safe & on-time airport drop service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportcab;